import { ISocialResult } from 'enhancers/withHomePageQuery';
import * as React from 'react';
import styled from 'styled-components';

interface IProps {
  result: ISocialResult | null;
}

export const SocialSection: React.SFC<IProps> = props => {
  if (!props.result) {
    return null;
  }

  const hasFacebook =
    props.result.ShowFacebook === 'yes' && props.result.FacebookHTML;
  const hasInsta = props.result.ShowInsta === 'yes' && props.result.InstaHTML;
  const basis = hasFacebook && hasInsta ? '50%' : '100%';

  return (
    <Container>
      {hasFacebook && (
        <Child
          basis={basis}
          dangerouslySetInnerHTML={{ __html: props.result.FacebookHTML || '' }}
        />
      )}
      {hasInsta && (
        <Child
          basis={basis}
          dangerouslySetInnerHTML={{ __html: props.result.InstaHTML || '' }}
        />
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
`;
const Child = styled.div<{ basis: string }>`
  flex: 0 0 ${p => p.basis};
`;

export default SocialSection;



// WEBPACK FOOTER //
// ./src/components/SocialSection/SocialSection.tsx